export default {
  appId: 32145,
  appName: '兔宝宝111',
  appIcon: 'http://pics.tutuapp.com/picture/app_ios/us/2020/05/14/17/x4cjbeeqhpsu.jpeg',
  time: '2020/05/01 13:22:22',
  channel: '英文 中文',
  platform: 'iOS',
  commitList: [
    // 按提交时间排序
    {
      user: 'huhua',
      commitTitle: '提交审核',
      commitTime: '2020/05/02 13:22:22',
      commitResult: '审核不通过',
      confirmTime: '2020/05/01 14:23:10'
    },
    {
      user: 'huhua',
      commitTitle: '第二次提交审核',
      commitTime: '2020/05/02 13:22:22',
      commitResult: '审核通过',
      confirmTime: '2020/05/03 14:23:10'
    }
  ]
}
